import React, {useMemo} from "react";
import ArticleSearchContainer from '../../../containers/ArticleSearchContainer';
import FormItemsContainer from '../../../containers/FormItemsContainer';
import { areaOrStr } from '../../../../utils/search';

const ResearchBtn = (props) => {
  const { areaKeywords, genreIds, setDetailSearch } = ArticleSearchContainer.useContainer();
  const {searchItems} = FormItemsContainer.useContainer();

  const genreItem = searchItems.find(s => s.title == "活動テーマ");
  const genreCheckedNames = useMemo(() => {
    return genreItem.items
      .filter(item => genreIds.includes(item.value))
      .map(item => item.label)
      .join(',');
  }, [genreItem]);
  const checkedNames = [...areaKeywords.split(areaOrStr), genreCheckedNames].filter(e => e).join(',');

  const open = () => {
    setDetailSearch(true)
    props.open()
  }

  return (
    <div className="m_researchBtn">
      <div className="isReSearch isBottom">
        <button onClick={open} className="p_btn isWide">
          <div>
            <div className="checkedNames p_overflowEllipsis">{checkedNames.length === 0 ? '検索条件を変更する' : checkedNames}</div>
            <div>条件変更や絞り込みなど設定できます</div>
          </div>
        </button>
      </div>
    </div>
  )
};

export default ResearchBtn;